import React, { useEffect, useState } from "react";
import { FormContext, useForm } from "react-hook-form";
import FormTitle from "../../FormElements/FormTitle";
import Button from "../../FormElements/Button";
import { useSelector } from "react-redux";
import { RootQuiz } from "../../../interfaces/quiz";
import Quiz from "../../../Pages/wizard/FormElements/quiz";

interface Props {
  setFormInsuredValid: any;
  onSubmit: any;
  loading: any;
  validOptionalValues: any;
  setValidOptionalValues: any;
  activeTab?: any
}

const InsuredForm = ({ onSubmit, setFormInsuredValid, loading, validOptionalValues, setValidOptionalValues, activeTab }: Props) => {
  const data = useSelector((state: any) => state.quiz.additionalInfo2Insured);

  const methods = useForm({
    mode: "onChange",
  });
  const {
    handleSubmit,
    errors,
    formState: { isValid },
  } = methods;

  const [orders, setOrders] = useState(["2.1.", "2.2."]);

  useEffect(() => {
    setFormInsuredValid(isValid);
  }, [isValid]);

  return (
    <>
      <FormTitle
        title="Completa los datos del contratante sobre lavado de activos y de financiamiento del terrorismo "
        parrafo="El contratante es la persona que es titular de la póliza y asegurado a la vez."
      />

      <FormContext {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Quiz
            data={data}
            orders={orders}
            setOrders={setOrders}
            setValidOptionalValues={setValidOptionalValues}
            variant={2}
          />

          <div className="form-register__border"></div>
          <div className="form-register__buttom form-step">
            <Button
              type="submit"
              className={loading ? "is-loading" : ""}
              disabled={!isValid || !validOptionalValues ? true : false}
             >
              Continuar
            </Button>
          </div>
        </form>
      </FormContext>
    </>
  );
};
export default InsuredForm;
